webpackJsonp([22],{

/***/ 1342:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1343);


/***/ }),

/***/ 1343:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactIntl = __webpack_require__(7);

var _it = __webpack_require__(1344);

var _it2 = _interopRequireDefault(_it);

var _it3 = __webpack_require__(1345);

var _it4 = _interopRequireDefault(_it3);

var _localeData = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _localeData.setTranslations)(_it4.default);
(0, _reactIntl.addLocaleData)(_it2.default);

/***/ }),

/***/ 1344:
/***/ (function(module, exports, __webpack_require__) {

!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=a())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,a){var t=!String(e).split(".")[1];return a?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},"year-short":{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},"month-short":{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},"day-short":{displayName:"g",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} g",other:"tra {0} gg"},past:{one:"{0} g fa",other:"{0} gg fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},"hour-short":{displayName:"h.",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} h",other:"tra {0} h"},past:{one:"{0} h fa",other:"{0} h fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},"minute-short":{displayName:"min",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} min",other:"tra {0} min"},past:{one:"{0} min fa",other:"{0} min fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}},"second-short":{displayName:"s",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} s",other:"tra {0} sec."},past:{one:"{0} s fa",other:"{0} sec. fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),

/***/ 1345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _it = __webpack_require__(1346);

var _it2 = _interopRequireDefault(_it);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _it2.default;

/***/ }),

/***/ 1346:
/***/ (function(module, exports) {

module.exports = {"1-to-1 Projects":"Progetti 1-to-1","99nonprofits":"99nonprofits","API integrations":"Integrazioni API","About":"Chi siamo","Account settings":"Impostazioni account","Affiliates":"Partners","Agencies":"Agencies","Become a designer":"Diventa designer","Blog":"Blog","Book cover design":"Copertine per libri","Brand guide":"Manuale di brand identity","Browse all categories":"Visualizza tutte le categorie","Browse categories":"Visualizza categorie","Browse contests":"Esplora i contest","Business card":"Biglietti da visita","Careers":"Carriere","Categories":"Categorie","Community":"Community","Company":"Azienda","Contact":"Contatti","Contests":"Contest","Credits":"Crediti","Design consultation":"Consulenza di design","Design contests":"Contest di Design","Design services":"Servizi di design","Designer resources":"Risorse per i designer","Designers":"Designers","Discover":"Scopri","Discover inspiration":"Scopri l'ispirazione","Earnings":"Guadagni accreditati","Featured partners":"Partner","Find a designer":"Trova un designer","Forum":"Forum","Get a design":"Ottieni un design","Getting started":"Inizia subito","Help":"Aiuto","Help Center":"Centro di Assistenza","Home":"Home","How it works":"Come funziona","Imprint":"Imprint","In the media":"Nei media","Log in":"Login","Log out":"Log out","Logo design":"Logo","Mark all as read":"Segnala tutte come già lette.","NDAs":"NDAs","Notifications":"Notifiche","Packaging design":"Packaging","Press releases":"Comunicati stampa","Pricing":"Prezzi","Privacy":"Privacy","Private messages":"Private messages","Profile":"Profilo","Projects":"Progetti","Recent winners":"Vincitori recenti","Resource Center":"Centro Risorse","Resources":"Servizi","See all messages":"Visualizza tutti i messaggi","See all notifications":"Vedi tutte le notifiche","Settings":"Impostazioni","Support":"Assistenza","T-shirt design":"Grafiche per T-shirt","Team":"Team","Terms":"Termini & Condizioni di Utilizzo","Testimonials":"Testimonial","Transactions":"Transazioni","Web page design":"Pagina web","Your clients":"I tuoi clienti","Your work":"Il tuo lavoro","{lang}":"{lang}","{phone}":"{phone}","© 99designs":"© 99designs","An error occured and we were unable to load your messages.":"Si è verificato un errore e non siamo riusciti ad inviare i tuoi messaggi.","Enable browser notificatons?":"Attivare le notifiche di browser?","Get updates on your device, even when 99designs is closed.":"Ricevi notifiche sul tuo dispositivo, anche quando la pagina di 99designs è chiusa.","Messages":"Messaggi","No notifications found.":"Nessuna notifica trovata.","No thanks":"No, grazie.","notification.body":"Fantastico, le notifiche sono abilitate! Personalizzare le notifiche nelle impostazioni dell'account.","notification.title":"Una notifica da 99designs","Please log in to view your messages":"Effettua l'accesso per visualizzare i tuoi messaggi","To start a message, find a designer and go to the envelope on their profile.":"Per iniziare una conversazione trova un designer e fai clic sull'icona busta sul suo profilo.","Unable to load messages":"Impossibile caricare messaggi","When you receive new messages, you will see them here.":"Quando ricevi nuovi messaggi potrai visualizzarli qui.","Yes please":"Sì, per favore","You have no private messages":"Non ci sono messaggi privati"}

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setTranslations = setTranslations;
exports.getTranslations = getTranslations;
var translations = {};

function setTranslations(t) {
    Object.assign(translations, t);
}

function getTranslations() {
    return translations;
}

/***/ })

},[1342]);


// WEBPACK FOOTER //
// locale-data/it-837665ffc0cc97da3adc.js